import { Attr, HasMany, HasOne, Model } from "spraypaint";

import SourceRecord from "shared/resources/SourceRecord";

import type Category from "./Category";
import type Outlet from "./Outlet";
import type RadioStationsBroadcastRecorder from "./RadioStationsBroadcastRecorder";
import type SourceGroup from "./SourceGroup";

@Model()
class RadioStation extends SourceRecord {
  static jsonapiType = "radio_stations";

  @Attr() advertisementRate: number;

  @Attr() aliases: string[];

  @Attr({ persist: false }) archivedAt: string;

  @HasOne() category: Category;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() ffmpegOptions: Record<string, any>;

  @Attr() gfkCode: string;

  @Attr() label: string;

  @Attr() languageCode: string;

  @Attr() locationId: number;

  @Attr() logoData: string;

  @Attr({ persist: false }) medium: string;

  @Attr() notes: string;

  @Attr() notifyOutageAfterMinutes: number;

  @Attr() notifyOutageViaPagerduty: boolean;

  @HasOne() outlet: Outlet;

  @Attr() outletId: number;

  @HasMany()
  radioStationsBroadcastRecorders: RadioStationsBroadcastRecorder[];

  @HasOne() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @Attr() streamUrl: string;

  @Attr() syndication: string;

  @Attr() tier: number;

  @Attr() transcriptionEngine: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() visible: boolean;
}

export default RadioStation;
